<template>
  <div class="router-transitions container-fluid flex-grow-1 container-p-y">
    <div class="d-flex flex-wrap align-items-baseline w-100 py-3 mb-2 head-bar">
      <h4 class="font-weight-bold">Home</h4>
      <b-form-checkbox v-if="showHomeOnStart" :checked="homeOnStart" class="home-on-start ml-auto" @change="homeOnStartChange">
        Open Home instead of the map
      </b-form-checkbox>
    </div>

    <!-- S0: nothing is published yet, so there is no map to send anyone to -->
    <HomeOnboarding v-if="!hasPublishedFloor" />

    <!-- S1 beside S2: "me" on the left, the workspace on the right. Either renders nothing
         when it has nothing it is allowed to show, and the other one then takes the width -->
    <div v-else class="home-columns">
      <HomeMyBookings class="home-columns__me" />
      <HomeSummary v-if="can(PN.SETTINGS_CRUD)" class="home-columns__workspace" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HomeMyBookings from '@/components/home/HomeMyBookings'
import HomeOnboarding from '@/components/home/HomeOnboarding'
import HomeSummary from '@/components/home/HomeSummary'
import { getHomeOnStart, hasNothingOnHome, hasPublishedFloor, setHomeOnStart } from '@/components/home/landing'
import * as PN from '@/utils/PermissionNames'

export default {
  name: 'home',
  components: { HomeMyBookings, HomeOnboarding, HomeSummary },
  data: () => ({ PN, homeOnStart: getHomeOnStart(), alwaysOnMap: null }),
  computed: {
    ...mapGetters('floor', ['floors']),
    ...mapGetters('rbac', ['can']),
    hasPublishedFloor() {
      return hasPublishedFloor(this.floors)
    },
    // such a reader starts on the map whatever is ticked
    showHomeOnStart() {
      return this.hasPublishedFloor && this.alwaysOnMap === false
    }
  },
  methods: {
    homeOnStartChange(value) {
      this.homeOnStart = value
      setHomeOnStart(value)
    }
  },
  async created() {
    this.alwaysOnMap = await hasNothingOnHome()
  }
}
</script>

<style scoped lang="scss">
// appwork's $custom-control-gutter; Bootstrap 4.6 pads the box width on top of it
.home-on-start {
  padding-left: 1.563rem;
}

.home-columns {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1.5rem;

  // 7 : 5, and one above the other once the pair would squeeze either
  &__me {
    flex: 7 1 480px;
    min-width: 0;
  }

  &__workspace {
    flex: 5 1 340px;
    min-width: 0;
  }
}
</style>
